import { BUTTON_SIZE, BUTTON_TYPE, DSButton } from '@repo/design-system/index'
import { useRouter } from 'next/router'
import { s_blog } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { COLORS } from '../../../../modules/vars'

const BlogDetailBackButtonSection = ({ isMobile }) => {
  const { back } = useRouter()
  const { t } = useTranslation()
  return (
    <div className={style.layout}>
      <div className={style.button}>
        <DSButton customBgColor={COLORS.GRAY100} size={BUTTON_SIZE.MD} type={BUTTON_TYPE.SOLID} onClick={() => back()}>
          <DSButton.Label customTxtColor={COLORS.GRAY600}>{t(s_blog.detail_page.btn)}</DSButton.Label>
        </DSButton>
      </div>
    </div>
  )
}

export default BlogDetailBackButtonSection

const style = {
  layout: `flex justify-center pt-[64px] pb-[64px] sm:pb-[120px]`,
  button: `w-[157px]`,
}
